// extracted by mini-css-extract-plugin
export default {"mainContainer":"Orcamento_mainContainer__-iyU0"};